import axios from "axios";
import { Base_URL } from "../../url";
import { toast } from "react-toastify";


export const getLeadSource = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/RawLeadSources/GetLeadSource`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch Data";
  }
};